export default "assets/images/icons/account-8d0e265c.svg";